
 
export type CSTOptions = {
	prefix?: string;
	suffix?: string;
	roundingMode?: "floor" | "ceil" | "round";
	currency?: string;
};

const defaultOptions: CSTOptions = {
	roundingMode: "floor",
	prefix: "",
	suffix: "",
};


/**
 * Formats a number or string with thousands separators and specified decimal precision
 * @param v - The number or string to format
 * @param precision - The number of decimal places to display (default: 2)
 * @param options - The options for the formatter
 * @param options.prefix - The prefix to add to the formatted string
 * @param options.suffix - The suffix to add to the formatted string
 * @param options.roundingMode - The rounding mode to use (default: "floor")
 * @param options.currency - The currency to use (default: "USD")
 * @returns A formatted string with locale-specific thousands separators
 */
export const cst = ( v:number|string, precision = 2, options: CSTOptions = defaultOptions ) => {
	const { prefix, suffix, roundingMode, } = options;
	return `${prefix}${Number(v).toLocaleString('en-US', { 
		minimumFractionDigits: precision,
		maximumFractionDigits: precision,
			...(options.currency ? { currency: options.currency, style: "currency", } : {}),
	})}${suffix}`;
}
